module.exports = __webpack_public_path__ + "static/media/crystal_springs_course.a16e28e8.jpeg";